import React, { useEffect, useState } from 'react';
import {MarketGroupItem} from "./MarketSelectionMenu";
import {MarketGroup} from "../../../../markets/marketMapping";
import {useTranslation} from "react-i18next";
import { createPortal } from 'react-dom';

type MarketsSelectPopupProps = {
    open: boolean;
    anchorEl: Element | null;
    items: MarketGroupItem[];
    replaceMarketGroups: (selectedMarketGroup: MarketGroup) => void;
    onClose: () => void;
};

export const MarketsSelectPopup = (props: MarketsSelectPopupProps) => {
    const { open, anchorEl, replaceMarketGroups, items, onClose } = props;
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const { t } = useTranslation();
    const popupRef = React.useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!open || !anchorEl) {
            setPosition({ top: 0, left: 0 });
            return;
        }
        if (open && anchorEl) {
            const rect = anchorEl.getBoundingClientRect();
            setPosition({
                top: rect.bottom + window.scrollY + 6, // расстояние под кнопкой
                left: rect.left + rect.width / 2
            });
        }
    }, [anchorEl, open]);

    useEffect(() => {
        if (!open) return;

        const handleClickOutside = (event: MouseEvent) => {
            if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open, onClose]);

    useEffect(() => {
        if (!open) return;

        const handleScroll = () => {
            onClose();
        };

        window.addEventListener("scroll", handleScroll, true);

        return () => {
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, [open, onClose]);


    if (!open || !anchorEl || (position.top == 0 && position.left === 0)) return null;

    return createPortal(
        <div
            className="absolute z-[999] left-1/2 -translate-x-1/2"
            style={{ top: position.top, left: position.left }}
            ref={popupRef}
        >
            <ul
                className="relative mt-[6px] w-[270px] rounded-md border bg-white shadow-md
                          before:content-[''] before:absolute before:top-[-6px] before:left-1/2 before:-translate-x-1/2
                          before:border-l-[6px] before:border-l-transparent
                          before:border-r-[6px] before:border-r-transparent
                          before:border-b-[6px] before:border-b-white
                          [&>*]:border-[#96A6B0] [&>*]:border-b [&>*:last-child]:border-b-0"
            >
                {items.map((el, index) => (
                    <li
                        key={index}
                        onClick={() => replaceMarketGroups(el.marketGroup)}
                        className="relative h-[60px] w-full pl-[36px] flex items-center text-md text-[#495159] hover:bg-gray-100 cursor-pointer"
                    >
                        {t(el.marketGroup)}
                    </li>
                ))}
            </ul>
        </div>,
        document.body
    );
};
